'use client'

import { useEffect, useState } from 'react'
import { useParams, usePathname } from 'next/navigation'
import VendorNotFound from "@/components/empty/VendorNotFound"
import NotFound from "@/components/NotFound"
import { sendClientRequest } from "@/utils/client-request"

export default function NotFoundPage() {
  const [vendor, setVendor] = useState<any>(null)
  const [checkedVendor, setCheckedVendor] = useState(false)
  const pathname = usePathname()
  const params = useParams()

  useEffect(() => {
    const fetchVendor = async () => {
      let domain = null

      if (params?.domain) {
        domain = params.domain as string
      } else if (typeof window !== 'undefined') {
        const hostname = window.location.hostname
        if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
          const hostParts = hostname.split('.')
          if (hostParts.length >= 3 && hostParts[0] !== 'www') {
            domain = hostParts[0]
          }
        }
      }

      if (!domain) {
        const pathSegments = pathname.split('/').filter(Boolean)
        domain = pathSegments[0]
      }

      if (!domain) {
        setCheckedVendor(true)
        return
      }

      try {
        const { data, error } = await sendClientRequest({ url: `/vendor/public/${domain}`, auth: false })
        if (!error && data) {
          setVendor(data)
        }
      } catch (error) {
        console.error('Error checking vendor:', error)
      } finally {
        setCheckedVendor(true)
      }
    }

    fetchVendor()
  }, [pathname])

  if (!checkedVendor) {
    return null
  }

  if (!vendor) {
    return <VendorNotFound />
  }

  return <NotFound vendor={vendor} />
}